import {
  IHolidaySearchParams,
  IHolidaySearchQueryArgs,
  IHolidaySearchQueryParams,
} from "../types/holiday-search-type";

type IEncodedCity = {
  city_id: string | number;
  city: string;
  country: string;
};

function parseNumber(value: unknown): number | undefined {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function parseCsv(value?: string) {
  if (!value) {
    return [];
  }

  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function encodedHolidayParams(data: IHolidaySearchQueryParams): string {
  const params = new URLSearchParams();
  if (data.city_id && data.city) {
    const encodedCity = encodeURIComponent(
      JSON.stringify({
        city_id: data.city_id,
        city: data.city,
        country: data.country ?? "",
      }),
    );

    params.set("city", encodedCity);
  }

  if (typeof data.min_price === "number") {
    params.set("min_price", String(data.min_price));
  }

  if (typeof data.max_price === "number") {
    params.set("max_price", String(data.max_price));
  }

  if (data.type?.length) {
    params.set("type", data.type.join(","));
  }

  if (data.holiday_for?.length) {
    params.set("holiday_for", data.holiday_for.join(","));
  }

  if (data.duration?.length) {
    params.set("duration", data.duration.join(","));
  }

  if (data.query?.trim()) {
    params.set("query", data.query.trim());
  }

  return params.toString();
}

export function decodedHolidayParams(
  params: IHolidaySearchParams,
): IHolidaySearchQueryParams {
  const parsedCity = params.city
    ? (JSON.parse(decodeURIComponent(params.city)) as IEncodedCity)
    : undefined;

  return {
    city_id: parsedCity?.city_id ? String(parsedCity.city_id) : undefined,
    city: parsedCity?.city ?? undefined,
    country: parsedCity?.country ?? undefined,
    min_price: parseNumber(params.min_price),
    max_price: parseNumber(params.max_price),
    type: parseCsv(params.type),
    holiday_for: parseCsv(params.holiday_for),
    duration: parseCsv(params.duration),
    query: params.query?.trim() || undefined,
  };
}

export function toHolidaySearchQueryArgs(
  data: IHolidaySearchQueryParams,
): IHolidaySearchQueryArgs {
  return {
    city_id: data.city_id ? String(data.city_id) : undefined,
    searchParams: data,
  };
}
